const toggleWebchatDisplay = () => {
  const iframeEl = document.getElementById('liberty-webchat-iframe');

  if (iframeEl) {
    const isVisible = iframeEl.getAttribute('data-visibility');
    iframeEl.style.display = isVisible === 'true' ? 'none' : 'block';

    if (!iframeEl.getAttribute('data-visibility')) {
      iframeEl.setAttribute('data-visibility', 'true');
      return;
    }

    iframeEl.setAttribute('data-visibility', isVisible === 'true' ? 'false' : 'true');
  }
};

export default toggleWebchatDisplay;
